<template>
  <q-form @reset="resetForm" ref="form" class="full-width no-shadow">
    <q-card style="height: calc(100vh - 120px)">
      <q-card-section class="bg-primary text-white">
        <div class="text-h6">Add Goal</div>
      </q-card-section>

      <q-card-section>
        <div class="row">
          <div class="col-12">
            <q-input
              v-model="formData.goal"
              label="Goal name"
              :rules="[(v) => !!v || 'Name is Required']"
            ></q-input>
          </div>
          <div class="col-12">
            <q-select
              v-model="formData.status"
              behavior="menu"
              :emit-value="true"
              map-options
              label="Status"
              :options="statusOptions"
              :rules="[(v) => !!v || 'Status is required']"
            ></q-select>
          </div>
        </div>
      </q-card-section>

      <div style="position: absolute; bottom: 0" class="q-pa-md full-width">
        <q-btn @click="create" type="reset" class="full-width" color="accent">
          Submit
        </q-btn>
      </div>
    </q-card>
  </q-form>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
      currentUserData: "auth/currentUserData",
    }),
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: function () {
      this.init();
    },
    file: function () {
      if (this.file != null) {
        this.uploadThumbnailReady();
      }
    },
  },
  data: () => ({
    // Extra Data
    formData: {},
    statusOptions: [
      {
        label: "Hidden",
        value: "hidden",
      },
      {
        label: "Visible",
        value: "visible",
      },
    ],

    myCroppa: {},

    file: null,
    uploadThumbnailLoading: false,
  }),
  mounted() {
    setTimeout(() => {
      this.init();
    }, 100);
  },
  methods: {
    init() {
      if (this.data != null) {
        this.formData = JSON.parse(JSON.stringify(this.data));
      } else {
        // this.formData = {
        //   status: "hidden",
        //   color: "#000000",
        // };
      }
    },
    async create() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$store.dispatch("goals/new", this.formData).then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });

              this.$refs.form.resetValidation();
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
        } else {
          this.$emit("loadingStateChanged", false);
        }
      });
    },
    save() {
      this.$emit("loadingStateChanged", true);
      this.$store.dispatch("goal/save", this.formData).then((result) => {
        this.$emit("loadingStateChanged", false);
        if (result.Result == "Success") {
          this.address = "";
          this.$emit("close", true);
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      });
    },
    resetForm() {
      this.formData.goal = null;
      this.formData.status = null;
      this.formData.color = null;
    },

    // SVG UPload

    // uploadThumbnail() {
    //   this.$refs.uploadThumbnailInput.$el.click();
    //   this.uploadThumbnailLoading = true;
    // },
    // uploadThumbnailReady() {
    //   let reader = new FileReader();
    //   reader.readAsDataURL(this.file[0]);
    //   reader.onload = () => {
    //     this.$store
    //       .dispatch("outcomes/uploadThumbnail", {
    //         id: this.formData.id,
    //         data: reader.result,
    //       })
    //       .then((res) => {
    //         this.$q.notify({
    //           message: "Thumbnail Saved",
    //           color: "positive",
    //         });
    //         this.file = null;
    //         this.uploadThumbnailLoading = false;
    //         this.formData.imgUrl = res.Response.DownloadUrl;
    //       });
    //   };
    // },
  },
};
</script>
